export default __webpack_public_path__ + "static/media/Blue Jackets.813bbcca.png";